var map = {
	"./Dashboard.vue": [
		2632,
		807
	],
	"./Error.vue": [
		6621,
		193
	],
	"./Instructions.vue": [
		4240,
		464
	],
	"./Login.vue": [
		4228,
		500
	],
	"./Notifications.vue": [
		812,
		935
	],
	"./OrderView.vue": [
		5827,
		792
	],
	"./Orders.vue": [
		4618
	],
	"./Organisations.vue": [
		4293,
		642
	],
	"./UserProfile.vue": [
		9932,
		543
	],
	"./Users.vue": [
		4005,
		131
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5249;
module.exports = webpackAsyncContext;